<template>
  <page>
    <div class="weixin-qrcode-warp">
       <!-- href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzIzMjUyODc4MA==&scene=110#wechat_redirect" -->
      <a>
        <img src="../../assets/imgs/qrcode.jpg" alt="">
      </a>
       <!-- href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzIzMjUyODc4MA==&scene=110#wechat_redirect" -->
      <a>
        <div class="weixin-qrcode-tips">Kindly click QR code for few seconds to follow Raysen official account before rent powerbank</div>
        <div class="weixin-qrcode-tips">Sila klik kod QR sepanjang beberapa saat untuk mengikuti akuan rasmi Raysen sebelum menyewa powerbank</div>
        <div class="weixin-qrcode-tips">请先长按二维码关注雷神公众号后才扫码租借</div>
      </a>
    </div>
  </page>
</template>

<script>
export default {
  data () {
    return {
      imgCode: ''
    }
  }
}
</script>

<style lang="less">
.weixin-qrcode-warp {
  font-size: 32px;
  padding: 40px;
  color: #666666;
  text-align: center;
  background-color: #fff;
  img {
    width: 100%;
  }
  .weixin-qrcode-tips {
    color: #010101;
    font-weight: 600;
    margin: 40px 0;
  }
}
</style>
